import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidKlankvoeten } from '../../../../mechanics/rid-klankvoeten/rid-klankvoeten';

@Component({
  selector: 'app-klankvoeten-page',
  imports: [RidKlankvoeten],
  templateUrl: './klankvoeten-page.html',
})
export class KlankvoetenPage {
  protected readonly router = inject(Router);
}
